import {Extensions, IExtensionInstance} from '@baidu/realtime-editor';
import PlaceHolderImg from '@/assets/img/flexBuilderPlaceHolder.png';
import {RenderComp, RenderInlineComp} from './render';
import {EntryTooltipContent} from './render/EntryTooltipContent';
import BtnFlexBuilder from './icon/btn-flex-builder';
// import BtnCustom from './icon/btn-custom.svg?tsx';
// import BtnCommentAndPrize from './icon/btn-comment-and-prize.svg?tsx';
// import BtnWordCloud from './icon/btn-word-cloud.svg?tsx';
// import BtnChart from './icon/btn-chart.svg?tsx';
import {createOnInsertResult} from './utils';
import {dataBus} from './render/data-bus';
import {GRAY_RELEASE_KEYS, initGray} from '@/grayRelease';
import {utils as KuUtils} from '@/kuTools/sdk/utils';
import {LogIdMap} from './constant';
import {createBuilder} from './render/request';
import {doc} from '@/kuTools/sdk/doc';
import {getIsSdkPage} from '@/kuSdk/view/DocViewAll/utils/isSdkPage';
import {getConfigs} from '@/kuSdk/view/DocViewAll/utils/configs';

const {isInGrayPromise: isMatchFlexBuilder} = initGray(GRAY_RELEASE_KEYS.flexBuilder);
const {isInGrayPromise: isMatchFlexBuilderLite} = initGray(GRAY_RELEASE_KEYS.flexBuilderLite);

const Extension = Extensions.createViewNode({
    type: 'flex-builder',
    render: {
        renderView: RenderComp,
        renderStaticView: RenderInlineComp,
    },
    comment: {
        getQuote: () => {
            return '随心搭';
        },
    },
    // @ts-ignore TODO: 暂时 as any 解决 morpho 构建产物没有 title 的类型声明的问题
    title: '随心搭' as any,
});

const EntryIcon = () => {
    return (
        <BtnFlexBuilder />
    );
};

/** 创建占位图 dom */
const createPlaceholderDOM = () => {
    const img = document.createElement('img');
    img.src = PlaceHolderImg;
    img.style.width = '100%';
    img.style.maxWidth = '500px';
    return img;
};
const placeholderDOM = createPlaceholderDOM();

export const createOnInsertResultWithBuilderId = async (type: 'custom' | 'template', templateId = '') => {
    // 点击入口时就创建好 builder id，主要是为了解决 undo redo 问题
    // eslint-disable-next-line max-len
    // https://console.cloud.baidu-int.com/devops/icafe/issue/so-kldoc-30445/show?source=copy-shortcut
    let builderId = '';
    try {
        const docGuid = doc.getDocId();
        const res = await createBuilder(docGuid, undefined, templateId);
        builderId = res?.builderId;
    } catch (error) {
        console.error(error);
    }

    if (!builderId) {
        // 如果创建 builder 失败，则在组件渲染时再尝试请求创建一次
        dataBus.setData(templateId);
        return createOnInsertResult(type);
    }
    return createOnInsertResult(type, builderId);
};

export default Extensions.createVoidCardPlugin({
    nodes: [Extension],
    // TODO: utils: InsertUtils 类型声明需要 RTE 暴露
    insert: (utils: any) => {
        const config: IExtensionInstance['insert'] = {
            title: '随心搭 Beta',
            tip: EntryTooltipContent,
            keywords: ['sxd', '随心搭', 'suixinda'],
            tag: true,
            toolbar: {
                enable: () => {
                    if (getIsSdkPage()) {
                        return !!getConfigs().flexBuilder;
                    }
                    return true;
                },
                guide: 'flex-builder',
            },
            icon: EntryIcon,
            className: 'flex-builder-entry',
            onInsert: async () => {
                KuUtils.kuLogger({
                    repId: LogIdMap.CreateCustomInit,
                    params: {from: utils.from},
                });
                return createOnInsertResultWithBuilderId('custom');
            },
            // TODO: MVP 版本，暂时不开放模板入口
            // children: [
            //     {
            //         title: '自定义',
            //         type: 'button',
            //         icon: () => (<BtnCustom />),
            //         keywords: ['zdy', '自定义', 'zidingyi'],
            //         onInsert: async () => {
            //             KuUtils.kuLogger({
            //                 repId: LogIdMap.CreateCustomInit,
            //                 params: {from: utils.from},
            //             });
            //             return createOnInsertResultWithBuilderId('custom');
            //         },
            //     },
            //     {
            //         type: 'divider',
            //     },
            //     {
            //         title: '评论抽奖',
            //         type: 'button',
            //         icon: () => (<BtnCommentAndPrize />),
            //         keywords: ['plcj', '评论抽奖', 'pinglunchoujiang'],
            //         onInsert: async () => {
            //             // TODO: 模板数据 在上线前确认 @zhupoyan
            //             const templateId = '_PDfTB1OkApVGt';
            //             const templateName = '评论抽奖';

            //             KuUtils.kuLogger({
            //                 repId: LogIdMap.CreateComponentByTemplate,
            //                 params: {
            //                     from: utils.from,
            //                     templateId,
            //                     templateName,
            //                 },
            //             });

            //             return createOnInsertResultWithBuilderId('template', templateId);
            //         },
            //     },
            //     {
            //         title: '词云图生成',
            //         type: 'button',
            //         icon: () => (<BtnWordCloud />),
            //         keywords: ['cytsc', '词云图生成', 'ciyuntushengcheng'],
            //         onInsert: async () => {
            //             // TODO: 模板数据 在上线前确认 @zhupoyan
            //             const templateId = 'a72SaOhLSlYsCD';
            //             const templateName = '词云图生成';

            //             KuUtils.kuLogger({
            //                 repId: LogIdMap.CreateComponentByTemplate,
            //                 params: {
            //                     from: utils.from,
            //                     templateId,
            //                     templateName,
            //                 },
            //             });

            //             return createOnInsertResultWithBuilderId('template', templateId);
            //         },
            //     },
            //     {
            //         title: '图表生成',
            //         type: 'button',
            //         icon: () => (<BtnChart />),
            //         keywords: ['tbsc', '图表生成', 'tubiaoshengcheng'],
            //         onInsert: async () => {
            //             // TODO: 模板数据 在上线前确认 @zhupoyan
            //             const templateId = 'umqunScVV2BM8X';
            //             const templateName = '图表生成';

            //             KuUtils.kuLogger({
            //                 repId: LogIdMap.CreateComponentByTemplate,
            //                 params: {
            //                     from: utils.from,
            //                     templateId,
            //                     templateName,
            //                 },
            //             });

            //             return createOnInsertResultWithBuilderId('template', templateId);
            //         },
            //     },
            // ],
        };

        let hasTrigUpdate = false;
        isMatchFlexBuilder().then((inGray) => {
            if (inGray && !hasTrigUpdate) {
                hasTrigUpdate = true;
                utils?.update?.(config);
            }
        });
        isMatchFlexBuilderLite().then((inGray) => {
            if (inGray && !hasTrigUpdate) {
                hasTrigUpdate = true;
                utils?.update?.(config);
            }
        });

        return false;
    },
    hooks: {
        onPaste: (node) => {
            if (node?.type !== 'flex-builder') {
                return;
            }
            node.isNeedUpload = true;
            // 此处用于chrome debug浏览器插件数据调试，同环境复制随心搭直接通过服务端接口创建，跨环境复制随心搭则通过node._builderData上的数据创建新随心搭
            // 如果是同环境复制，这里可删掉_builderData，利用服务端提供的随心搭复制能力即可
            if (node._sourceHost === location.hostname) {
                delete node._builderData;
            }
        },
        onPrint: () => {
            return placeholderDOM;
        },
        onMaterialInsert: (node) => {
            // 从模板库拖拽含有随心搭组件的内容进正文后，会触发该钩子函数，此时需要标记一下节点，触发组件的重新创建 builder id 的流程
            if (node && node.type === 'flex-builder') {
                node.isNeedUpload = true;
            }
        },
    },
    drag: {
        dragRender: () => {
            return placeholderDOM;
        },
    },
});
